var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSaturation = function SvgSaturation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#212121",
    d: "M10 0A10.01 10.01 0 0 0 0 10a10.01 10.01 0 0 0 10 10 10.01 10.01 0 0 0 10-10A10.01 10.01 0 0 0 10 0m-.323 19.355c-5-.194-9.032-4.29-9.032-9.355S4.677.839 9.677.645z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffc300",
    d: "M9.64 19.338V.666c-2.375 0-4.653.984-6.332 2.734S.685 7.526.685 10.002s.943 4.851 2.623 6.602 3.957 2.735 6.332 2.735z",
    opacity: 0.5
  })));
};
export default SvgSaturation;